import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import Slider from "react-slick";
import { Container, Row, Col, Button } from "reactstrap";
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { DateTime } from "luxon";
import queryString from "query-string";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

import EventContext from "../contexts/event";
import UserContext from "../contexts/user";
import { EslidesEvent, Presentation, SchedulePresentationData, Version } from "../types/presentation";
import Footer from "./footer";
import SproutVideo from "./sprout-video";
import Plays from "./plays";
import { BackArrow } from "./svgs";
import getEncodedImageUrl from "../helpers/get-encoded-image";
import { PreLoader } from "./preloader";
import { useHistory } from "react-router-dom";
import LocaleSwitcher from "./locale-switcher";
import TopBar from "./top-bar";
import SideBarBtns from "./sidebar-btns";

import Forum from "../components/forum";

import { secondsToTime } from "../helpers";
import SliderCustom from "./custom-slider";
import MobileBottomNav from "./mobile-bottom-nav";

const VideoComponent: React.FC<{
  event: EslidesEvent;
  presentation: Presentation;
  forum?: boolean;
  locale: string;
  setLocale: (arg0: string) => void;
}> = ({
  event,
  presentation,
  // forum = false,
  forum,
  locale,
  setLocale,
}) => {
    const eventContext = useContext(EventContext);
    const userContext = useContext(UserContext);

    const [showForumSidebar, setShowForumSidebar] = useState(forum);
    const [showMobileForumSidebar, setShowMobileForumSidebar] = useState(forum);

    const intl = useIntl();
    const [progress, setProgress] = useState(0);
    const [currentThumbnail, setCurrentThumbnail] = useState(0);
    // const [swap, setSwap] = useState(false);
    const [v, setV] = useState(null);
    const [w, setW] = useState(null);
    const [played, setPlayed] = useState(false);
    const [swap, setSwap] = useState(false);
    const [isForum, setIsForum] = useState(forum);
    const [cornerStyle, setCornerStyle] = useState({});
    const [videoControlsHeight, setVideoControlsHeight] = useState(0);

    const [enableRender, setEnableRender] = useState(false);
    const [playSlider, setPlaySlider] = useState(false);
    const [viewFullSliders, setViewFullSliders] = useState(false);
    const location = useLocation();
    const [isVirtual] = useState(
      queryString.parse(location.search).viewmode === "virtual"
    );
    const [isVideoLanding] = useState(
      queryString.parse(location.search).viewmode === "videolanding"
    );
    const [isIframe] = useState(queryString.parse(location.search).iframe);
    const [versions, setVersions] = useState<Version[]>([]);
    const sliderRef = useRef() as React.MutableRefObject<Slider>;

    const screen = useFullScreenHandle();

    // handle video screen control
    const handleScreen = () => {
      if (screen.active) {
        screen.exit();
      } else {
        screen.enter();
      }
    };

    const [scrollPosition, setScrollPosition] = useState(0);

    // video page scroll handler function
    const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
      // getting page container
      const vTop = document.getElementById("video-mini-container");
      // @ts-ignore
      let height = vTop.offsetTop - position;

      // getting page container
      const width =
        document.getElementsByClassName("logo-container")[0].clientWidth;
      // getting height aspect ratio based on element width
      const videoAspectHeight = presentation?.webcam?.id
        ? (document.getElementsByClassName("logo-container")[0].clientWidth * 9) /
        16
        : 0;
      // set video controller height
      setVideoControlsHeight(presentation?.webcam?.id ? videoAspectHeight : 0);
      setCornerStyle({
        position: "fixed",
        left: 0,
        top: height,
        width,
        zIndex: 99,
        height: videoAspectHeight,
      });

      console.log("handleScroll", width, videoAspectHeight);
    };

    // init load use effect callback
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    useEffect(() => {
      const GetVersions = async () => {
        try {
          if (presentation?.versions) {
            setVersions(presentation.versions);
          }
        } catch (error) {
          console.log("Error fetching versions:", error);
        }
      }
      GetVersions();
    }, [presentation]);

    console.log(versions, "versionsnnnsnnssn he he he heeee");

    useEffect(() => {
      if (!presentation) {
        return;
      }
      let video: any = null;
      let webcam: any = null;
      if (presentation.video && presentation.video.id) {
        // get sprout video player element
        // @ts-ignore
        video = new global.SV.Player({ videoId: presentation.video.id });

        if (v == null) {
          setV(video);
        }
      }

      if (presentation.webcam && presentation.webcam.id) {
        // get sprout video player element
        // @ts-ignore
        webcam = new global.SV.Player({ videoId: presentation.webcam.id });
        if (w == null) {
          setW(webcam);
        }
      }
      // check video is not undefined
      if (video) {
        video.bind("play", (e: any) => {
          // set player state is true
          setPlayed(true);
          // check webcam is not undefined
          if (webcam) {
            // play webcam video
            webcam.play();
          }
        });
        // video bind pause callback
        video.bind("pause", (e: any) => {
          // check webcam is not undefined
          if (webcam) {
            webcam.pause();
          }
        });
        // video bind progress callback
        video.bind("progress", (e: any) => {
          setProgress(e.data.time);
        });
      }

      if (webcam) {
        // video bind ready callback
        webcam.bind("ready", function (e: any) {
          webcam.setVolume(1);
          video.setVolume(0);
        });
        // video bind progress callback
        webcam.bind("progress", (e: any) => {
          if (
            video.getCurrentTime() + 0.5 < webcam.getCurrentTime() ||
            video.getCurrentTime() - 0.5 > webcam.getCurrentTime()
          ) {
            // seek video with time
            video.seek(e.data.time);
          }
        });
      }
    }, [presentation]);

    // checking components height and assign it to sidebar components
    useEffect(() => {
      // TODO
      const width =
        document.getElementsByClassName("logo-container")[0].clientWidth;
      // const height = document.getElementsByClassName('logo-container')[0].clientHeight;
      const vTop = document.getElementById("video-mini-container");
      const videoAspectHeight = presentation?.webcam?.id
        ? (document.getElementsByClassName("logo-container")[0].clientWidth * 9) /
        16
        : 0;
      setVideoControlsHeight(presentation?.webcam?.id ? videoAspectHeight : 0);
      setCornerStyle({
        position: "fixed",
        left: 0,
        top: vTop && vTop.offsetTop,
        width,
        zIndex: 99,
        height: videoAspectHeight,
      });
    }, [setCornerStyle, presentation]);

    // set volume on webcam video
    useEffect(() => {
      let getVolume = "";
      if (v) {
        // @ts-ignore
        getVolume = v.getVolume();

        if (w) {
          // @ts-ignore
          w.setVolume(1);
        }
      }
    });
    useEffect(() => {
      // check playSlider is not undefined
      if (playSlider) {
        try {
          if (!presentation || !presentation.thumbnails) {
            return;
          }
          // seek the video to based on the selected slide

          const thumbnail = presentation.thumbnails.findIndex(
            (t) => t.time > progress * 1000
          );

          // check sliderRef is not undefined
          if (sliderRef && sliderRef.current) {
            if (thumbnail === -1) {
              // seek the video to based on the selected slide
              // @ts-ignore
              sliderRef.current.slickGoTo(presentation.thumbnails.length - 1);
              setCurrentThumbnail(presentation.thumbnails.length - 1);
            } else {
              // seek the video to based on the selected slide
              // @ts-ignore
              sliderRef.current.slickGoTo(thumbnail === 0 ? 0 : thumbnail - 1);
              setCurrentThumbnail(thumbnail === 0 ? 0 : thumbnail - 1);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }, [progress, presentation, sliderRef]);

    // seek video handler
    const seekVideo = (value: any) => {
      setEnableRender((enableRender) => !enableRender);
      if (w) {
        // if webcam is present, seek webcam, it will internally seek the video
        // @ts-ignore
        w.seek(value);
      }
      if (v) {
        // @ts-ignore
        v.seek(value);
      }
      if (!played) {
        if (v) {
          // @ts-ignore
          v.play();
        }
        if (w) {
          // if webcam is present, seek webcam, it will internally seek the video
          // @ts-ignore
          w.play();
        }
      }
    };

    // custom video seek function
    const seekCustomVideo = (value: any, videoRef: any, webcamRef: any) => {
      setEnableRender((enableRender) => !enableRender);
      // check videoRef is not undefined
      if (videoRef) {
        // @ts-ignore
        videoRef.pause();
      }
      // check webcamRef is not undefined
      if (webcamRef) {
        // if webcam is present, seek webcam, it will internally seek the video
        // @ts-ignore
        webcamRef.pause();
      }
      // check webcamRef is not undefined
      if (webcamRef) {
        // if webcam is present, seek webcam, it will internally seek the video
        // @ts-ignore
        webcamRef.seek(value);
      }
      // check videoRef is not undefined
      if (videoRef) {
        // @ts-ignore
        videoRef.seek(value);
      }
      // check videoRef is not undefined
      if (videoRef) {
        // @ts-ignore
        videoRef.play();
      }
      // check webcamRef is not undefined
      if (webcamRef) {
        // if webcam is present, seek webcam, it will internally seek the video
        // @ts-ignore
        webcamRef.play();
      }
    };

    // seek callback function for inner child components
    const seekVideoCallback = useCallback(
      (value: any, videoRef: any, webcamRef: any) => {
        seekCustomVideo(value, videoRef, webcamRef);
      },
      [enableRender]
    );

    let history = useHistory();

    if (!presentation) {
      return <PreLoader />;
    }

    console.log("presentation", presentation.video);

    const handleVideoEdit = () => {
      console.log("clciked");
      // For React Router v5
      history.push("/test", { presentation });

      // For React Router v6
      // navigate('/presentation-page', { state: { presentation } });
    };

    console.log(presentation, "presentation data here");
    console.log(versions, "versions data here");


    return (
      <FullScreen handle={screen}>
        <SideBarBtns
          presentation={presentation}
          setShowForumSidebar={setShowForumSidebar}
          forumIsOpen={showForumSidebar}
          forum
        />
        <div
          className={`grid-contianer quiz-user-container video-grid-container`}
        >
          <LocaleSwitcher locale={locale} setLocale={setLocale} />
          <TopBar
            presentation={presentation}
            setShowForumSidebar={setShowForumSidebar}
            forumIsOpen={showForumSidebar}
            tab={-1}
            forum={true}
            hasVideo={presentation.video ? true : false}
          />
          <div className="sidebar public-video-sidebar">
            <div className="sidebar-main quiz-user">
              <div className="logo-container videoPlayer-logo-container">
                {!isIframe && (
                  // <div className="event-logo-container">
                  <div className="">
                    {event.logo && (
                      <img
                        height={60}
                        src={getEncodedImageUrl(event.logo, 110, 110, "contain")}
                        alt="logo"
                      />
                    )}
                    <span>{event.name}</span>
                  </div>
                )}
                <span className="day m-t-20">
                  {!isVirtual && (
                    <span className="day-text">
                      {intl.formatMessage({ id: "day" })} {presentation.day}
                    </span>
                  )}
                  <span className="useless-line"></span>
                  {!isVirtual && presentation.date && (
                    <span className="date">
                      {DateTime.fromFormat(
                        presentation.date,
                        "yyyy-MM-dd"
                      ).toFormat("D")}
                    </span>
                  )}
                </span>
                <div
                  style={{ height: videoControlsHeight }}
                  id="video-mini-container"
                  className="video-mini-container d-none d-lg-block"
                >
                  <div className="video-controls">
                    <Button
                      onClick={() => {
                        handleScreen();
                      }}
                      color="primary"
                    >
                      <img src="/icons/expand-1.svg" alt="expand" />
                    </Button>
                    {presentation.webcam && presentation.webcam.id && (
                      <Button
                        onClick={() => {
                          setSwap(!swap);
                        }}
                        className="m-l-10"
                        color="primary"
                      >
                        <img src="/icons/expand-2.svg" alt="expand" />
                      </Button>
                    )}
                  </div>
                </div>
                <h6>{presentation.name}</h6>
                <div className="speaker-deails-sidebar">
                  {presentation.speaker_info &&
                    presentation.speaker_info.picture ? (
                    <img
                      src={getEncodedImageUrl(
                        presentation.speaker_info.picture,
                        56,
                        56
                      )}
                      alt="speaker"
                    />
                  ) : (
                    <img src="/images/plimgspeaker.png" alt="speaker" />
                  )}
                  <div>
                    <p>
                      {presentation.speaker_info &&
                        presentation.speaker_info.title}{" "}
                      {presentation.speaker_info &&
                        presentation.speaker_info.firstName}{" "}
                      {presentation.speaker_info &&
                        presentation.speaker_info.lastName}
                    </p>
                    {!isVirtual && (
                      <span className="time-room-container">
                        {secondsToTime(presentation.time || 0)} -{" "}
                        {secondsToTime(presentation.end_time || 0)}
                        <span className="room-name">
                          {presentation.room_info && presentation.room_info.name}
                        </span>
                      </span>
                    )}
                  </div>
                </div>
                <br></br>
                {/* {presentation._id} */}
                <div className="back-link p-l-0 link-flex m-t-20">
                  {!isVideoLanding && (
                    <Button
                      color="link"
                      onClick={() =>
                        history.push(
                          `/${eventContext.slug}${document.location.search}`
                        )
                      }
                    >
                      <BackArrow />
                      {intl.formatMessage({ id: "button.common.back" })}
                    </Button>
                  )}
                  {event.show_video_views && (
                    <Plays presentation_id={presentation._id} />
                  )}
                </div>
              </div>

              <div className="nav-conatiner pad-top-0 h-100">
                <div
                  className="ad-container"
                  dangerouslySetInnerHTML={{
                    __html: presentation.information
                      ? presentation.information
                      : userContext.currentEvent.ad,
                  }}
                ></div>
              </div>
              <Footer />
              <div
                className={`forum-container-sidebar ${showForumSidebar ? "show-forum" : ""
                  }`}
              >
                <div className={`${userContext.user ? "" : "login-needeed"}`}>
                  <Forum presentation_id={presentation._id} />
                </div>
              </div>
            </div>
          </div>
          <div className="main video-main-bot-fix relative overflow-div">
            <Container fluid>
              <MobileBottomNav
                presentation={presentation}
                tab={showForumSidebar ? 1 : 5}
                setShowForumSidebar={setShowForumSidebar}
              />

              {showForumSidebar && userContext.user ? (
                <div className={`mobile-forum-contents d-block d-lg-none`}>
                  <Forum presentation_id={presentation._id} />
                </div>
              ) : showForumSidebar ? (
                <div
                  className="show-forum-sidebar-desktop"
                  style={{ textAlign: "center", marginTop: "vh" }}
                >
                  <Button
                    className="promt-user-login-btn  btn-primary"
                    onClick={() => userContext.setShowLogin(true)}
                  >
                    {" "}
                    {intl.formatMessage({ id: "button.login.access" })}
                  </Button>
                </div>
              ) : (
                ""
              )}

              <div
                className={`row ${showForumSidebar
                  ? "show-forum-sidebar-mobile show-forum-sidebar-mobile-hide"
                  : ""
                  }`}
                style={
                  showForumSidebar
                    ? {}
                    : { display: "flex", justifyContent: "center" }
                }
              >
                <Col lg={8}>
                  <div
                    className={
                      swap
                        ? showForumSidebar
                          ? "video-big-container-forum-action"
                          : "video-big-container "
                        : "mini-player"
                    }
                    style={swap ? {} : cornerStyle}
                  >
                    {!swap ? (
                      <div
                        onClick={() => {
                          if (v !== null) {
                          }
                        }}
                        className="overlay"
                      ></div>
                    ) : null}

                    {presentation.webcam && presentation.webcam.id && (
                      <SproutVideo
                        {...presentation.webcam}
                        skip={presentation.skip || 0}
                        className="video"
                        volume={1}
                        bigPlayButton={false}
                        showcontrols={false}
                        seekBar={false}
                      />
                    )}
                  </div>

                  <div
                    className={
                      swap
                        ? "mini-player"
                        : showForumSidebar
                          ? "video-big-container-forum-action"
                          : "video-big-container"
                    }
                    style={swap ? cornerStyle : {}}
                  >
                    {presentation.video ? (
                      <SproutVideo
                        {...presentation.video}
                        skip={presentation.skip || 0}
                        className="video"
                        bigPlayButton={true}
                        volume={
                          presentation.webcam && presentation.webcam.id ? 0 : 1
                        }
                        showcontrols={true}
                      />
                    ) : (
                      <div
                        style={
                          showForumSidebar
                            ? {
                              textAlign: "center",
                              paddingTop: "30vh",
                              paddingRight: "20vh",
                            }
                            : { textAlign: "center", padding: "30vh" }
                        }
                      >
                        <i>No video</i>
                      </div>
                    )}
                  </div>
                </Col>
              </div>

              <div
                className={`row ${showForumSidebar
                  ? "show-forum-sidebar-mobile show-forum-sidebar-mobile-hide"
                  : ""
                  }`}
                style={
                  showForumSidebar
                    ? {}
                    : { display: "flex", justifyContent: "center" }
                }
              >
                <Col lg={8}>
                  <div className={`video-header-panel d-none d-sm-block`}>
                    <span></span>
                  </div>

                  <div className={`d-none d-sm-block`}>
                    <a
                      className={`slide-video-button `}
                      onClick={(event1) => setViewFullSliders(!viewFullSliders)}
                    >
                      <span className={`link`}>
                        {!viewFullSliders
                          ? intl.formatMessage({ id: "video.all.sliders" })
                          : intl.formatMessage({ id: "video.hide.sliders" })}
                      </span>
                    </a>
                  </div>
                  {/* all slides enable button */}
                  {presentation.video && (
                    <div
                      className={`
                    ${showForumSidebar
                          ? "slides-summary-forum-action"
                          : " slides-summary"
                        }
                    `}
                    >
                      {/*show screen slider video components*/}
                      {!viewFullSliders && v && sliderRef ? (
                        <SliderCustom
                          videoRef={v}
                          webcamRef={w}
                          sliderRef={sliderRef}
                          enableRender={enableRender}
                          seekVideo={seekVideoCallback}
                          singleVersion={presentation}
                          currentThumbnail={currentThumbnail}
                        />
                      ) : (
                        ""
                      )}

                      {/* slider all components view */}
                      {viewFullSliders && (
                        <div className="">
                          <div className="slides-all-container">
                            {versions.map((version) => {
                              if (version.online == true) {
                                return version?.thumbnails
                                  .sort((a, b) => a.time - b.time)
                                  .map((thumbnail, index) => (
                                    <a
                                      key={thumbnail.time}
                                      data-time={thumbnail.time}
                                      href="/"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCurrentThumbnail(index);
                                        seekVideoCallback(
                                          thumbnail.time / 1000,
                                          v,
                                          w
                                        );
                                      }}
                                      className={`item ${currentThumbnail === index
                                        ? "active-slide"
                                        : ""
                                        } pb-2`}
                                    >
                                      <div className="m-10">
                                        <img
                                          className="img-fluid"
                                          src={getEncodedImageUrl(
                                            thumbnail.id.indexOf("e-slides.net") >
                                              -1
                                              ? thumbnail.id.split(
                                                "e-slides.net/"
                                              )[1]
                                              : thumbnail.id,
                                            150,
                                            61
                                          )}
                                          alt={`Slide ${index + 1}`}
                                        />
                                      </div>
                                    </a>
                                  ))
                              }
                            })}
                          </div>
                        </div>
                      )}
                      {/* slider  mobile view */}
                      <div className="d-block d-lg-none">
                        <div className="slides-mob-container">
                          {versions.map((version) => {
                            if (version.online == true) {
                              return version?.thumbnails
                                .sort((a, b) => a.time - b.time)
                                .map((thumbnail, index) => (
                                  <a
                                    key={thumbnail.time}
                                    data-time={thumbnail.time}
                                    href="/"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setCurrentThumbnail(index);
                                      seekVideoCallback(
                                        thumbnail.time / 1000,
                                        v,
                                        w
                                      );
                                    }}
                                    className={`item ${currentThumbnail === index}`}
                                  >
                                    <div className="m-10">
                                      <img
                                        className="img-fluid"
                                        src={getEncodedImageUrl(
                                          thumbnail.id.indexOf("e-slides.net") > -1
                                            ? thumbnail.id.split("e-slides.net/")[1]
                                            : thumbnail.id,
                                          274,
                                          174
                                        )}
                                        alt={`Slide ${index + 1}`}
                                      />
                                    </div>
                                  </a>

                                ))
                            }
                          })}
                        </div>
                      </div>
                    </div>
                  )}

                </Col>

              </div>
              {/* <Button onClick={handleVideoEdit}>Go to Video Editor Page</Button> */}
            </Container>
          </div>
        </div>
      </FullScreen>
    );
  };

export default VideoComponent;
